/**
 * User Status Badge Component
 * Part of TASK-334: Frontend Admin Panel (migrated to the TASK-661 semantic system)
 *
 * Displays user status (active/pending/deactivated) and invitation state via the
 * shared ui/StatusBadge: active/accepted = success, invited = info, pending =
 * attention, expired = urgent, deactivated = unavailable.
 */

import React from 'react';
import type { InvitationStatus } from '../../../types/admin';
import { USER_STATUS_LABELS, INVITATION_STATUS_LABELS } from '../../../types/admin';
import { StatusBadge, type SemanticStatus } from '../../ui/status-badge';

interface UserStatusBadgeProps {
  isActive: boolean;
  invitationStatus?: InvitationStatus;
  size?: 'sm' | 'md';
}

const INVITATION_SEMANTIC: Record<string, SemanticStatus> = {
  invited: 'info',
  pending: 'attention',
  accepted: 'success',
  expired: 'urgent',
};

const UserStatusBadge: React.FC<UserStatusBadgeProps> = ({
  isActive,
  invitationStatus,
  size = 'md',
}) => {
  let status: SemanticStatus;
  let label: string;

  if (!isActive) {
    status = 'unavailable';
    label = USER_STATUS_LABELS.deactivated;
  } else if (invitationStatus && invitationStatus !== 'accepted') {
    status = INVITATION_SEMANTIC[invitationStatus] ?? 'info';
    label = INVITATION_STATUS_LABELS[invitationStatus];
  } else {
    status = 'success';
    label = USER_STATUS_LABELS.active;
  }

  return (
    <StatusBadge status={status} size={size === 'sm' ? 'sm' : 'md'} icon={null}>
      {label}
    </StatusBadge>
  );
};

export default UserStatusBadge;
